<template>
  <div>
    <el-form
      label-width="120px"
      class="add-contragent_form"
      label-position="top"
    >
      <el-row :gutter="24" class="add-contragent_row-content">
        <el-col :span="12">
          <el-form-item label="ИНН">
            <el-input
              v-model="contragent_data.inn"
              type="text"
              placeholder="Введите ИНН"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button class="el-select" type="info" plain @click="checkINN">
              Проверить ИНН
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row v-if="ifIssetINN" :gutter="24" class="add-contragent_row-content">
      <el-col :span="12">
        <ul class="fast_select">
          <span>Результат поиска</span>
          <li class="c-quick-pick__item">
            <b>Контрагент уже есть в вашем списке:</b><br />
            <p class="add-contragent-contragent">{{ issetContragentName }}</p>
          </li>
        </ul>
      </el-col>
      <el-col :span="12">
        <el-button
          class="el-select"
          type="primary"
          style="color: white !important"
          @click="toEdit"
        >
          Редактировать
        </el-button>
      </el-col>
    </el-row>
    <el-row v-if="ifInnResult" :gutter="24" class="add-contragent_row-content">
      <el-col :span="12">
        <ul v-if="ifInnResult" class="fast_select">
          <span>Результат поиска</span>
          <li class="c-quick-pick__item">
            <p class="add-contragent-contragent">
              {{ ownerNameText }}
            </p>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row v-if="ifInnError" :gutter="24" class="add-contragent_row-content">
      <el-col :span="24">
        <ul v-if="ifInnError" class="fast_select">
          <span>Результат поиска</span>
          <li class="c-quick-pick__item">
            <p class="add-contragent-contragent">
              ИНН указан не верно или более не существует
            </p>
          </li>
        </ul>
      </el-col>
    </el-row>
    <form-contragent
      :edit-type="false"
      :show-passport-id="showPassportId"
      :contragent-data="contragent_data"
      :if-inn-result="ifInnResult"
      :contrag-list="contragList"
      @saveContragent="saveContragent"
      @clearDialogForm="clearDialogForm"
      @checkRs="checkRs"
      @checkBik="checkBik"
      @onChangeOrg="onChangeOrg"
    />
    <passport-user-organization
      :id="showPassportId"
      :dialog-visible="dialogVisible"
      :close-modal="onCloseOrg"
      @create="onCreateOrg"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapMutations } from 'vuex'
import { validateRs } from '@/helpers/validate-req'
import FormContragent from '@/components/Contragents/FormContragent'
import PassportUserOrganization from '@/components/Forms/PassportUserOrganization'
import getError from '@/api/getErrors'

const UserOrgs = RepositoryFactory.get('userOrganizations')
const Contragents = RepositoryFactory.get('contragents')
const Check = RepositoryFactory.get('check')

export default {
  name: 'NewContragents',
  components: { PassportUserOrganization, FormContragent },
  props: {
    org: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      errorRs: {
        code: 0,
        message: '',
      },
      contragent_data: {
        user_id: this.$store.state.userProfile.id,
        user_org_inn: this.$store.state.userProfile.current.organization.inn,
        inn: this.org ? this.org.inn : '',
        org_name: '',
        phone: '',
        email: '',
        address: '',
        address_kladr: '',
        bik: '',
        name_bank: '',
        core_account: '',
        checking_account: '',
      },
      contract: {
        sourceModelName: 'contragents',
        sourceId: 0,
        documentType: 'auto_sts', // СРСТ
      },
      contragList: [],
      ownerNameText: '',
      issetContragentName: '',
      ifIssetINN: false,
      ifInnResult: false,
      ifInnError: false,
      dialogVisible: false,
      showPassportId: null,
    }
  },
  computed: {
    isUploadContract() {
      return this.$canAction('uploadContract', this.userInfo)
    },
  },
  watch: {
    org(newVal) {
      this.clearDialogForm()
      this.contragent_data.inn = newVal.inn
    },
  },
  mounted() {
    if (this.ifEdditTrue) {
      this.contragent_data = this.contragent
    }
  },
  methods: {
    ...mapMutations(['createContragent']),
    onChangeOrg(id) {
      this.showPassportId = id
      this.dialogVisible = true
    },
    onCloseOrg() {
      this.dialogVisible = false
    },
    onCreateOrg(contr) {
      this.onCloseOrg()

      if (contr) {
        this.$emit('edited', contr, 1)
      }
    },
    toEdit() {
      this.$emit('edited', this.contragent_data)
    },
    checkRs() {
      if (this.contragent_data.checking_account) {
        this.contragent_data.checking_account =
          this.contragent_data.checking_account.replace(/\s/g, '')
      }

      return validateRs(
        this.contragent_data.checking_account,
        this.contragent_data.bik,
        this.errorRs,
      )
    },
    checkBik() {
      Check.bik(this.contragent_data.bik).then(response => {
        if (response.data && !response.data.error) {
          this.contragent_data.name_bank = response.data.name
            .split('&quot;')
            .join("'")
          this.contragent_data.core_account = response.data.ks
        } else {
          this.contragent_data.name_bank = 'Банк не найден'
          this.contragent_data.core_account = ''
        }
      })
    },
    isErrors(data) {
      const error = getError.isError(data)

      if (error.isError) {
        this.$alert(error.message)

        return true
      }

      return false
    },
    saveContragent(docs = false) {
      // if (this.checkRs()) {
      Contragents.postContragents(this.contragent_data)
        .then(response => {
          if (response.status === 201) {
            this.createContragent(response.data)
            this.clearDialogForm()
            this.$emit('saved')

            if (docs) {
              this.contragent_data = response.data
              this.toEdit()
            }
          }
        })
        .catch(e => {
          this.isErrors(e)
        })
      // } else {
      //   this.$message.warning(this.errorRs.message)
      // }
    },
    clearDialogForm() {
      for (let key in this.contragent_data) {
        if (!['user_id', 'user_org_inn'].includes(key)) {
          this.contragent_data[key] = ''
        }
      }
      this.ifIssetINN = false
      this.ifInnResult = false
      this.ifInnError = false
    },
    setEdit(contragents) {
      this.ifIssetINN = true
      this.ifInnResult = false
      this.issetContragentName = contragents[0].org_name
      this.contragent_data = contragents[0]
    },
    setNew() {
      this.ifIssetINN = false
      Check.inn(this.contragent_data.inn)
        .then(responses => {
          if (!responses.data) {
            this.ownerNameText = 'ИНН указан не верно или более не существует'
            this.ifInnError = true
          } else {
            this.getUserOrgs(this.contragent_data.inn)
            this.ownerNameText = ''
            this.ifInnError = false
            this.contragent_data.org_name = responses.data.short_name
            this.contragent_data.address = responses.data.address

            if (this.org) {
              const { bik, name_bank, core_account, checking_account } =
                this.org.userOrg

              this.contragent_data.bik = bik
              this.contragent_data.name_bank = name_bank
              this.contragent_data.core_account = core_account
              this.contragent_data.checking_account = checking_account
            }
            this.ifInnResult = true
          }
        })
        .catch(() => console.log('Ошибка'))
    },
    getUserOrgs(inn) {
      UserOrgs.getByINN(inn)
        .then(res => {
          const { status, data } = res

          if (status === 200 && data) {
            this.contragList = data.items.filter(c => Boolean(c.bik))
          }
        })
        .catch(() => console.log('Ошибка'))
    },
    checkINN() {
      this.ifInnError = false
      this.ifInnResult = false

      if (this.contragent_data.inn === '') {
        this.setNew()
      } else {
        Contragents.findContragentsByInn(this.contragent_data.inn).then(
          responses => {
            if (responses.data.items.length > 0) {
              this.setEdit(responses.data.items)
            } else {
              this.setNew()
            }
          },
        )
      }
    },
  },
}
</script>

<style lang="sass">

.add-contragent_form
  .el-form-item__label
    line-height: 10px
.add-contragent_row-content
  display: flex
  justify-content: space-between
  align-items: flex-end
.add-contragent-contragent
  font-size: 14px
  font-weight: 500
  color: #e6a23c
</style>
